import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "sonner";
import "@/index.css";

import LoginPage from "@/pages/Login";
import DashboardPage from "@/pages/Dashboard";
import ProvidersPage from "@/pages/Providers";
import AggregatorsPage from "@/pages/Aggregators";
import BrandsPage from "@/pages/Brands";
import FxRatesPage from "@/pages/FxRates";
import MonthlyRunPage from "@/pages/MonthlyRun";
import MonthlyOverviewPage from "@/pages/MonthlyOverview";
import InvoicesPage from "@/pages/Invoices";
import PaymentsPage from "@/pages/Payments";
import InsightsPage from "@/pages/Insights";
import ReportsPage from "@/pages/Reports";
import TallyPage from "@/pages/Tally";
import AdminReconciliationPage from "@/pages/AdminReconciliation";
import AdminUsersPage from "@/pages/AdminUsers";
import AdminDbConfigPage from "@/pages/AdminDb";
import AdminSqlPage from "@/pages/AdminSql";
import AdminCurrenciesPage from "@/pages/AdminCurrencies";

function Protected() {
  const { user, checked } = useAuth();
  if (!checked) return <div className="min-h-screen flex items-center justify-center text-[var(--wv-text-3)]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function AdminOnly() {
  const { user, checked } = useAuth();
  if (!checked) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

function GuestOnly() {
  const { user, checked } = useAuth();
  if (!checked) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route element={<GuestOnly />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>
          <Route element={<Protected />}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/monthly-run" element={<MonthlyRunPage />} />
            <Route path="/monthly-overview" element={<MonthlyOverviewPage />} />
            <Route path="/providers" element={<ProvidersPage />} />
            <Route path="/aggregators" element={<AggregatorsPage />} />
            <Route path="/brands" element={<BrandsPage />} />
            <Route path="/fx-rates" element={<FxRatesPage />} />
            <Route path="/invoices" element={<InvoicesPage />} />
            <Route path="/payments" element={<PaymentsPage />} />
            <Route path="/reports" element={<ReportsPage />} />
            <Route path="/tally" element={<TallyPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route element={<AdminOnly />}>
              <Route path="/admin/users" element={<AdminUsersPage />} />
              <Route path="/admin/currencies" element={<AdminCurrenciesPage />} />
            <Route path="/admin/reconciliation" element={<AdminReconciliationPage />} />
              <Route path="/admin/db" element={<AdminDbConfigPage />} />
              <Route path="/admin/sql" element={<AdminSqlPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
